var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEcuador(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_370)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 19.9999C0 8.95425 8.95437 -0.00012207 20 -0.00012207C31.0456 -0.00012207 40 8.95425 40 19.9999L20 21.739L0 19.9999Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.67627 29.9999C6.13447 35.9777 12.5973 39.9999 20 39.9999C27.4028 39.9999 33.8656 35.9777 37.3238 29.9999L20 28.6956L2.67627 29.9999Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3237 30C39.0255 27.0583 40 23.643 40 20H0C0 23.643 0.974531 27.0583 2.67625 30H37.3237Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 26.9564C23.8419 26.9564 26.9564 23.8419 26.9564 19.9999C26.9564 16.158 23.8419 13.0435 19.9999 13.0435C16.158 13.0435 13.0435 16.158 13.0435 19.9999C13.0435 23.8419 16.158 26.9564 19.9999 26.9564Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 24.3478C17.6026 24.3478 15.6522 22.3973 15.6522 19.9999V17.3913C15.6522 14.9938 17.6027 13.0435 20 13.0435C22.3974 13.0435 24.3478 14.9939 24.3478 17.3913V19.9999C24.3478 22.3974 22.3975 24.3478 20 24.3478Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9565 9.56519H21.739C21.739 8.60472 20.9604 7.82605 19.9999 7.82605C19.0394 7.82605 18.2608 8.60472 18.2608 9.56519H13.0433C13.0433 10.5257 13.88 11.3043 14.8404 11.3043H14.7825C14.7825 12.2649 15.5611 13.0435 16.5216 13.0435C16.5216 14.004 17.3002 14.7826 18.2608 14.7826H21.739C22.6996 14.7826 23.4782 14.004 23.4782 13.0435C24.4387 13.0435 25.2173 12.2649 25.2173 11.3043H25.1594C26.1199 11.3043 26.9565 10.5257 26.9565 9.56519V9.56519Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_370"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcuador);
export default __webpack_public_path__ + "static/media/ecuador.f7fc0213e8044daffed6883474209249.svg";
export { ForwardRef as ReactComponent };